// Angular Files
import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files

// Other External Files

// Component Files

// Teller Online Library Files
import { TellerOnlineIconsModule } from 'teller-online-libraries/icons';
import { MatCardModule } from '@angular/material/card';
import { TellerOnlineSharedModule } from 'libraries/shared/src/lib/module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { TellerOnlinePaymentMethodComponent } from './payment-method.component';

@NgModule({
    declarations: [TellerOnlinePaymentMethodComponent],
    imports: [
        RouterModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        TellerOnlineIconsModule,
        TellerOnlineSharedModule
    ],
    exports: [TellerOnlinePaymentMethodComponent]
})
export class TellerOnlinePaymentMethodModule {}
